import React from "react";
import SiteFooter from "../../general/components/layout/SiteFooter";
import SiteNavbar from "../../general/components/layout/SiteNavbar";
import { serviceDetails, serviceActions } from "../assets/serviciosDetalle";
import ServiceCta from "../components/ServiceCta";
import ServiceHero from "../components/ServiceHero";
import ServiceSection from "../components/ServiceSection";
import serviciosNavTheme from "../components/serviciosNavTheme";

const service = serviceDetails["marketing-publicidad"];
const marketingNavTheme = {
    ...serviciosNavTheme,
    primary: "#e8536b",
    primaryDark: "#be123c",
    primaryLight: "#fecdd3",
    pale: "rgba(232, 83, 107, 0.08)",
};

export default function MarketingYPublicidadEnSalud() {
    return (
        <div className="servicios servicio-detalle service-page-marketing-publicidad">
            <SiteNavbar activeSection="servicios" ctaLabel="Contactar" ctaHref={serviceActions.whatsapp} navTheme={marketingNavTheme} />
            <ServiceHero service={service} />
            {service.sections.map((section) => (
                <ServiceSection key={`${section.label}-${section.title}`} section={section} />
            ))}
            <ServiceCta service={service} />
            <SiteFooter/>
        </div>
    );
}
